"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styles = require("@material-ui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _Spinner = _interopRequireDefault(require("../../Component/Spinner/Spinner"));
var _excluded = ["children", "className", "colorScheme", "compact", "component", "disabled", "displayErrors", "hasError", "hasValidation", "icon", "iconClassName", "inputClassName", "inputRef", "invertScheme", "loading", "setDisplayErrorsState", "setLoadingState", "theme", "type"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*:: import { type ThemeType } from '../../style/ThemeTypes';*/
var BUTTON = 'button';
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  var disabledStyles = {
    borderColor: theme.colors.lightGrey,
    backgroundColor: theme.colors.lightGrey,
    color: theme.colors.battleshipGrey,
    cursor: 'default' // not-allowed
  };
  var paddingRight = 16;
  var paddingLeft = 16;
  var marginRight = 8;
  return {
    root: _objectSpread(_objectSpread(_objectSpread({}, theme.typography.baseText), theme.mixins.truncate), {}, {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      verticalAlign: 'middle',
      paddingTop: '.375rem',
      paddingRight: theme.functions.toRem(paddingRight),
      paddingBottom: '.375rem',
      paddingLeft: theme.functions.toRem(paddingLeft),
      border: "1px solid ".concat(theme.colors.pastelGrey),
      borderRadius: theme.variables.borderRadiusSmall,
      backgroundColor: theme.colors.white,
      color: theme.colors.black,
      fontWeight: 500,
      cursor: 'pointer',
      '&:active, &:hover': {
        opacity: 1
      },
      '&$disabled': disabledStyles,
      '&:disabled': {
        cursor: 'default',
        // not-allowed
        '& [mask]': {
          fill: disabledStyles.color
        }
      }
    }),
    icon: _objectSpread(_objectSpread({}, theme.typography.baseText), {}, {
      display: 'flex',
      marginRight: theme.functions.toRem(marginRight),
      fontSize: theme.functions.toRem(theme.variables.icon),
      '& [mask]': {
        fill: theme.colors.white
      }
    }),
    children: _objectSpread({}, theme.mixins.truncate),
    compact: _objectSpread(_objectSpread({}, theme.typography.smallText), {}, {
      borderRadius: theme.variables.borderRadiusSmall,
      paddingTop: '.125rem',
      paddingBottom: '.125rem'
    }),
    compactIcon: {
      fontSize: '1rem'
    },
    colorScheme: _objectSpread(_objectSpread({}, theme.mixins.colorScheme), {}, {
      '&$disabled': disabledStyles
    }),
    invertScheme: _objectSpread(_objectSpread({}, theme.mixins.invertScheme), {}, {
      '& [mask]': {
        fill: theme.colors.slateGrey
      },
      '&$disabled': _objectSpread(_objectSpread({}, disabledStyles), {}, {
        '& [mask]': {
          fill: disabledStyles.color
        }
      })
    }),
    disabled: {},
    usesLoading: {
      // Account for half of Spinner width and margin
      paddingLeft: theme.functions.toRem(paddingLeft + parseInt(theme.variables.icon) / 2 + marginRight / 2),
      // Account for other half of Spinner width and margin
      paddingRight: theme.functions.toRem(paddingRight + parseInt(theme.variables.icon) / 2 + marginRight / 2)
    },
    loading: {
      paddingLeft: theme.functions.toRem(paddingLeft),
      // Reset padding-left when loading
      paddingRight: theme.functions.toRem(paddingRight) // Reset padding-right when loading
    }
  };
});
/*:: type Props = {
  children: string | React.Element<typeof FormattedMessage>,
  className?: string,
  colorScheme?: string,
  compact?: boolean,
  component: React.ElementType,
  disabled?: boolean,
  displayErrors?: boolean,
  hasError?: boolean,
  hasValidation?: boolean,
  icon?: React.Node,
  iconClassName?: string,
  inputClassName?: string,
  inputRef?: React.ElementRef<*>,
  invertScheme?: boolean,
  loading?: boolean,
  setDisplayErrorsState?: (displayErrors: boolean) => mixed,
  setLoadingState?: (loading: boolean) => mixed,
  theme?: ThemeType,
  type?: 'button' | 'reset' | 'submit'
};*/
var ButtonInput = exports.ButtonInput = function ButtonInput(_ref /*:: */) {
  var children = _ref /*:: */.children,
    className = _ref /*:: */.className,
    colorScheme = _ref /*:: */.colorScheme,
    compact = _ref /*:: */.compact,
    Component = _ref /*:: */.component,
    disabled = _ref /*:: */.disabled,
    displayErrors = _ref /*:: */.displayErrors,
    hasError = _ref /*:: */.hasError,
    hasValidation = _ref /*:: */.hasValidation,
    icon = _ref /*:: */.icon,
    iconClassName = _ref /*:: */.iconClassName,
    inputClassName = _ref /*:: */.inputClassName,
    ref = _ref /*:: */.inputRef,
    invertScheme = _ref /*:: */.invertScheme,
    loading = _ref /*:: */.loading,
    setDisplayErrorsState = _ref /*:: */.setDisplayErrorsState,
    setLoadingState = _ref /*:: */.setLoadingState,
    theme = _ref /*:: */.theme,
    type = _ref /*:: */.type,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, invertScheme ? classes.invertScheme : classes.colorScheme, true), classes.compact, compact), classes.disabled, disabled), classes.usesLoading, (loading === true || loading === false) && !icon), classes.loading, loading && !icon), className),
    "data-color": colorScheme || undefined,
    disabled: disabled || loading,
    type: Component === BUTTON ? type : undefined,
    ref: ref
  }, props), (icon || loading) && /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames.default)(classes.icon, (0, _defineProperty2.default)({}, classes.compactIcon, compact), iconClassName)
  }, loading ? /*#__PURE__*/React.createElement(_Spinner.default, null) : icon), /*#__PURE__*/React.createElement("span", {
    className: classes.children
  }, children));
};
ButtonInput.displayName = 'ButtonInput';
ButtonInput.defaultProps = {
  component: BUTTON,
  type: BUTTON
};
var _default = exports.default = ButtonInput;
//# sourceMappingURL=ButtonInput.js.map